// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiSvgIcon-root.disabled, .MuiTypography-root.disabled{
    color: rgba(255, 255, 255, 0.3);
}
.MuiSvgIcon-root.enabled, .MuiTypography-root.enabled{
    color: #ffffff;
}
.MuiBox-root.trainingStatus{
    position: absolute;
    left: -8px;
    top: 10px;
    display: flex;
    align-items: end;
    width: 100%;
    justify-content: end
}
.MuiChip-root.chipStyle{
    color: #ffffff;
    border-radius: 5px;
    background-color: #4C40AB;
    font-size: 9px;
    font-family: var(--font-family-primary);
    font-weight: 400;
    height: 15px;
}
.MuiPaper-root.disabled{
    cursor: not-allowed;
}
.MuiPaper-root.enabled{
    cursor: pointer;
}
.enhanceIcons{
    width: 40px;
    height: 40px;
    object-fit: contain;
}
.MuiTypography-root.uploadText{
    font-size: 16px;
    font-weight: 400;
    font-family: var(--font-family-primary);
    color: #ffffff;
    text-align: center;
    margin-top: 10px;
}
.MuiTypography-root.productText{
    font-size: 14px;
    font-weight: 400;
    font-family: var(--font-family-primary);
    color: #ffffff;
    text-align: left;
    margin-top: 5px;
}
.my-masory{
    display: flex;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Upload/Upload.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;AACnC;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX;AACJ;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;IACb,SAAS;AACb","sourcesContent":[".MuiSvgIcon-root.disabled, .MuiTypography-root.disabled{\n    color: rgba(255, 255, 255, 0.3);\n}\n.MuiSvgIcon-root.enabled, .MuiTypography-root.enabled{\n    color: #ffffff;\n}\n.MuiBox-root.trainingStatus{\n    position: absolute;\n    left: -8px;\n    top: 10px;\n    display: flex;\n    align-items: end;\n    width: 100%;\n    justify-content: end\n}\n.MuiChip-root.chipStyle{\n    color: #ffffff;\n    border-radius: 5px;\n    background-color: #4C40AB;\n    font-size: 9px;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    height: 15px;\n}\n.MuiPaper-root.disabled{\n    cursor: not-allowed;\n}\n.MuiPaper-root.enabled{\n    cursor: pointer;\n}\n.enhanceIcons{\n    width: 40px;\n    height: 40px;\n    object-fit: contain;\n}\n.MuiTypography-root.uploadText{\n    font-size: 16px;\n    font-weight: 400;\n    font-family: var(--font-family-primary);\n    color: #ffffff;\n    text-align: center;\n    margin-top: 10px;\n}\n.MuiTypography-root.productText{\n    font-size: 14px;\n    font-weight: 400;\n    font-family: var(--font-family-primary);\n    color: #ffffff;\n    text-align: left;\n    margin-top: 5px;\n}\n.my-masory{\n    display: flex;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
